import Vue from 'vue'
import axios from 'axios'
import { processAthlete } from '@/store/modules/athletes/detail'

// state
export const state = {
  isPoolStandingsLoading: false,
  poolStandings: {},
}

// getters
export const getters = {
  getRoundPullStandings: ({ poolStandings }) => roundId => poolStandings[roundId] || [],
}
// mutations
export const mutations = {
  fetchRoundPoolStandingsStarted(state) {
    state.isPoolStandingsLoading = true
  },
  fetchRoundPoolStandingsSuccess(state, { roundId, scores, userId }) {
    state.isPoolStandingsLoading = false
    Vue.set(
      state.poolStandings,
      roundId,
      scores.map(score => {
        const prediction = score.prediction
          ? {
            athletes: score.prediction.athletes.map(athlete => processAthlete(athlete)),
            ...score.prediction,
          } : false
        return {
          ...score,
          prediction,
          isMe: userId === score.user_id,
        }
      }).sort(({ position: positionA }, { position: positionB }) => {
        if (positionB < positionA) { return 1 }
        if (positionB > positionA) { return -1 }
        return 0
      }).sort(({ isMe }) => isMe ? -1 : 1))
  },
  fetchRoundPoolStandingsFailed(state) {
    state.isPoolStandingsLoading = false
  },

}
// actions
export const actions = {
  async fetchRoundPoolStandings({ commit, rootGetters }, { roundId }) {
    let scores = null
    try {
      commit('fetchRoundPoolStandingsStarted')
      scores = await axios.get(`round/${roundId}/friendsScores`)
      commit('fetchRoundPoolStandingsSuccess', { roundId, scores, userId: rootGetters['auth/user'].id })
    } catch (e) {
      console.log(e)
      commit('fetchRoundPoolStandingsFailed')
    }
    return scores
  },
}
